import type { LumpsumAllocationCategory, LumpsumAllocationUnderReviewRecommendation } from '../../../../api/allocation.types'
import {
  ALLOCATION_CATEGORY_BUCKET_TITLES,
  PlanCategoryBucketKey,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { AllocationUnderReviewFundCard } from '../cards/AllocationUnderReviewFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type AllocationUnderReviewBucketAccordionProps = {
  category: LumpsumAllocationCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function AllocationUnderReviewBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: AllocationUnderReviewBucketAccordionProps) {
  const underReviewRecommendations = getCategoryBucketItems<LumpsumAllocationUnderReviewRecommendation>(category?.underReviewRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.ALLOCATION,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.underReviewRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={ALLOCATION_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.underReviewRecommendations]}
      count={underReviewRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumAllocation,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: ALLOCATION_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.underReviewRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {underReviewRecommendations.map((recommendation, recommendationIndex) => (
        <AllocationUnderReviewFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          categoryName={category?.categoryName ?? ''}
          showBottomDivider={recommendationIndex < underReviewRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
